const currency = [
  { value: 1, label: 'AED' },
  { value: 2, label: 'AFN' },
  { value: 3, label: 'ALL' },
  { value: 4, label: 'AMD' },
  { value: 5, label: 'ANG' },
  { value: 6, label: 'AOA' },
  { value: 7, label: 'ARS' },
  { value: 8, label: 'AUD' },
  { value: 9, label: 'AWG' },
  { value: 10, label: 'AZN' },
  { value: 11, label: 'BAM' },
  { value: 12, label: 'BBD' },
  { value: 13, label: 'BDT' },
  { value: 14, label: 'BGN' },
  { value: 15, label: 'BHD' },
  { value: 16, label: 'BIF' },
  { value: 17, label: 'BMD' },
  { value: 18, label: 'BND' },
  { value: 19, label: 'BOB' },
  { value: 20, label: 'BOV' },
  { value: 21, label: 'BRL' },
  { value: 22, label: 'BSD' },
  { value: 23, label: 'BTN' },
  { value: 24, label: 'BWP' },
  { value: 25, label: 'BYN' },
  { value: 26, label: 'BZD' },
  { value: 27, label: 'CAD' },
  { value: 28, label: 'CDF' },
  { value: 29, label: 'CHE' },
  { value: 30, label: 'CHF' },
  { value: 31, label: 'CHW' },
  { value: 32, label: 'CLF' },
  { value: 33, label: 'CLP' },
  { value: 34, label: 'CNY' },
  { value: 35, label: 'COP' },
  { value: 36, label: 'COU' },
  { value: 37, label: 'CRC' },
  { value: 38, label: 'CUC' },
  { value: 39, label: 'CUP' },
  { value: 40, label: 'CVE' },
  { value: 41, label: 'CZK' },
  { value: 42, label: 'DJF' },
  { value: 43, label: 'DKK' },
  { value: 44, label: 'DOP' },
  { value: 45, label: 'DZD' },
  { value: 46, label: 'EGP' },
  { value: 47, label: 'ERN' },
  { value: 48, label: 'ETB' },
  { value: 49, label: 'EUR' },
  { value: 50, label: 'FJD' },
  { value: 51, label: 'FKP' },
  { value: 52, label: 'GBP' },
  { value: 53, label: 'GEL' },
  { value: 54, label: 'GHS' },
  { value: 55, label: 'GIP' },
  { value: 56, label: 'GMD' },
  { value: 57, label: 'GNF' },
  { value: 58, label: 'GTQ' },
  { value: 59, label: 'GYD' },
  { value: 60, label: 'HKD' },
  { value: 61, label: 'HNL' },
  { value: 62, label: 'HRK' },
  { value: 63, label: 'HTG' },
  { value: 64, label: 'HUF' },
  { value: 65, label: 'IDR' },
  { value: 66, label: 'ILS' },
  { value: 67, label: 'INR' },
  { value: 68, label: 'IQD' },
  { value: 69, label: 'IRR' },
  { value: 70, label: 'ISK' },
  { value: 71, label: 'JMD' },
  { value: 72, label: 'JOD' },
  { value: 73, label: 'JPY' },
  { value: 74, label: 'KES' },
  { value: 75, label: 'KGS' },
  { value: 76, label: 'KHR' },
  { value: 77, label: 'KMF' },
  { value: 78, label: 'KPW' },
  { value: 79, label: 'KRW' },
  { value: 80, label: 'KWD' },
  { value: 81, label: 'KYD' },
  { value: 82, label: 'KZT' },
  { value: 83, label: 'LAK' },
  { value: 84, label: 'LBP' },
  { value: 85, label: 'LKR' },
  { value: 86, label: 'LRD' },
  { value: 87, label: 'LSL' },
  { value: 88, label: 'LYD' },
  { value: 89, label: 'MAD' },
  { value: 90, label: 'MDL' },
  { value: 91, label: 'MGA' },
  { value: 92, label: 'MKD' },
  { value: 93, label: 'MMK' },
  { value: 94, label: 'MNT' },
  { value: 95, label: 'MOP' },
  { value: 96, label: 'MRU' },
  { value: 97, label: 'MUR' },
  { value: 98, label: 'MVR' },
  { value: 99, label: 'MWK' },
  { value: 100, label: 'MXN' },
  { value: 101, label: 'MXV' },
  { value: 102, label: 'MYR' },
  { value: 103, label: 'MZN' },
  { value: 104, label: 'NAD' },
  { value: 105, label: 'NGN' },
  { value: 106, label: 'NIO' },
  { value: 107, label: 'NOK' },
  { value: 108, label: 'NPR' },
  { value: 109, label: 'NZD' },
  { value: 110, label: 'OMR' },
  { value: 111, label: 'PAB' },
  { value: 112, label: 'PEN' },
  { value: 113, label: 'PGK' },
  { value: 114, label: 'PHP' },
  { value: 115, label: 'PKR' },
  { value: 116, label: 'PLN' },
  { value: 117, label: 'PYG' },
  { value: 118, label: 'QAR' },
  { value: 119, label: 'RON' },
  { value: 120, label: 'RSD' },
  { value: 121, label: 'RUB' },
  { value: 122, label: 'RWF' },
  { value: 123, label: 'SAR' },
  { value: 124, label: 'SBD' },
  { value: 125, label: 'SCR' },
  { value: 126, label: 'SDG' },
  { value: 127, label: 'SEK' },
  { value: 128, label: 'SGD' },
  { value: 129, label: 'SHP' },
  { value: 130, label: 'SLL' },
  { value: 131, label: 'SOS' },
  { value: 132, label: 'SRD' },
  { value: 133, label: 'SSP' },
  { value: 134, label: 'STN' },
  { value: 135, label: 'SVC' },
  { value: 136, label: 'SYP' },
  { value: 137, label: 'SZL' },
  { value: 138, label: 'THB' },
  { value: 139, label: 'TJS' },
  { value: 140, label: 'TMT' },
  { value: 141, label: 'TND' },
  { value: 142, label: 'TOP' },
  { value: 143, label: 'TRY' },
  { value: 144, label: 'TTD' },
  { value: 145, label: 'TWD' },
  { value: 146, label: 'TZS' },
  { value: 147, label: 'UAH' },
  { value: 148, label: 'UGX' },
  { value: 149, label: 'USD' },
  { value: 150, label: 'USN' },
  { value: 151, label: 'UYI' },
  { value: 152, label: 'UYU' },
  { value: 153, label: 'UYW' },
  { value: 154, label: 'UZS' },
  { value: 155, label: 'VES' },
  { value: 156, label: 'VND' },
  { value: 157, label: 'VUV' },
  { value: 158, label: 'WST' },
  { value: 159, label: 'XAF' },
  { value: 160, label: 'XAG' },
  { value: 161, label: 'XAU' },
  { value: 162, label: 'XBA' },
  { value: 163, label: 'XBB' },
  { value: 164, label: 'XBC' },
  { value: 165, label: 'XBD' },
  { value: 166, label: 'XCD' },
  { value: 167, label: 'XDR' },
  { value: 168, label: 'XOF' },
  { value: 169, label: 'XPD' },
  { value: 170, label: 'XPF' },
  { value: 171, label: 'XPT' },
  { value: 172, label: 'XSU' },
  { value: 173, label: 'XTS' },
  { value: 174, label: 'XUA' },
  { value: 175, label: 'XXX' },
  { value: 176, label: 'YER' },
  { value: 177, label: 'ZAR' },
  { value: 178, label: 'ZMW' },
  { value: 179, label: 'ZWL' }
];
export default currency;